import { FooterLinksProps } from 'types/footer-links'
import { capitalizeAllWords } from 'utils/generalUtils'
import FooterLinkSection from './FooterLinkSection'

const FooterLinks = ({ listing }: FooterLinksProps) => {
  const nearbyCities = listing?.nearbyCities
  const directoryJobDescription = listing?.site?.directoryJobDescription
  const listingCity = listing?.city?.name
  const listingState = listing?.state?.name
  const footerKeywords = listing?.footerKeywords
  const isJob = listing?.job

  // Data for Nearby Cities links
  const capitalizedKeyword = capitalizeAllWords(directoryJobDescription)
  const suffix = isJob ? ' Jobs' : ''
  const listingLocationName = (listingCity ? listingCity + ', ' : '') + listingState
  const nearbyCitiesHeader = `Find ${capitalizedKeyword}${suffix} in ${listingLocationName}`

  // Data for More in City links
  const prefix = isJob ? ' jobs in ' : ' in '
  const moreInCityHeading = `More ${prefix}${listingLocationName}`

  return (
    <>
      {nearbyCities && nearbyCities.length > 0 && (
        <FooterLinkSection heading={nearbyCitiesHeader} linkArray={nearbyCities} isJob={isJob} />
      )}
      <FooterLinkSection heading={moreInCityHeading} linkArray={footerKeywords} isJob={isJob} />
    </>
  )
}

export default FooterLinks
